import { IconButton, Typography, Tooltip, Avatar, AvatarGroup } from "@mui/material";
import { memo } from "react";
import { useAppContext } from "src/hooks";
import { UserAvatar } from "src/components";


const ChatMessageReaction = ({ emojiList, handleRemoveEmoji }) => {
    const { dispatch_get_user_profile, chatList, currentChat } = useAppContext();
    return (
        <div className="reacted-icons-container">
            <div>
                <AvatarGroup
                    max={10}
                    spacing={2}
                    sx={{
                        '& .MuiAvatar-root': {
                            width: 15,
                            height: 15,
                            padding: '3px',
                            fontSize: '13px',
                        }
                    }}
                >
                    {emojiList.map((emojiItem) => {
                        let isUserSelected = emojiItem.reacting_user_ids.includes(dispatch_get_user_profile().user_id);
                        return <Tooltip
                            key={emojiItem.unified}
                            arrow
                            // title={emojiItem.emoji + "   " + emojiItem?.reacting_user_ids?.length}
                            title={
                                <div className="tooltip-emoji-user">
                                    <div className="emoji-title">{emojiItem.emoji}</div>
                                    <div className="emoji-users-container">
                                        {emojiItem.reacting_user_ids?.map((userId, index) => {

                                            let findedUser = currentChat.user.find((item) => {
                                                return item.user_id == userId
                                            });
                                            return <div key={index} className="d-flex mb-1">
                                                <UserAvatar
                                                    image={findedUser ? findedUser.image : dispatch_get_user_profile().image}
                                                    name={findedUser ? findedUser?.first_name + " " + findedUser?.last_name : "You"}
                                                    sx={{ width: "12px", height: "12px", mr: 1 }}
                                                    alt="sender"
                                                />
                                                <div>{findedUser ? findedUser?.first_name + " " + findedUser?.last_name : "You"}</div>
                                            </div>
                                        })}
                                        
                                    </div>
                                </div>
                            }
                            placement="top"
                        >
                            <Avatar className="emoji-avatar-icon" sx={{ backgroundColor: isUserSelected ? "#6fd6a1" : "" }}
                                onClick={() => handleRemoveEmoji(emojiItem)}
                            >
                                {emojiItem.emoji}
                            </Avatar>
                        </Tooltip>
                    })}
                </AvatarGroup>
            </div>
        </div>
    );
}

export default memo(ChatMessageReaction);